import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { WorkOrderService } from "../../../services/index";
declare var google;

@Component({
  selector: "approved-Work-Order",
  templateUrl: "approvedWorkOrder.html",
})
export class approvedWorkOrder implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  selected = [];
  isLoading: boolean = false;
  selectedWoNo: any;
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  saveEvent: any;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    wo_no: "",
    approved: "Approved",
    cutting_ratio: "",
    width: "",
    brand: "",
    fab_type: "",
    style : '',
    fab_width :'',
    fab_style : "",
    wash_shrink : ''
  };
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "ref_no",
    orderDir: "desc",
  };
  approvedList = ["Approved", "Not Approved", "All"];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;

  no_of_wo: number = 0;
  tot_mtrs: number = 0;
  tot_qty: number = 0;
  no_of_colors: number = 0;
  no_of_pcs: number = 0;

  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  user: any;
  total_mtrs: number = 0;
  total_qty: number = 0;
  total_wo: number = 0;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private woservice: WorkOrderService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    if (this.menu.param == "fabric_store") {
      if (
        this.filter.width != "" &&
        this.filter.cutting_ratio != "" &&
        this.filter.brand != "" &&
        this.filter.fab_type != ""
      ) {
        this.columns = [
          {
            prop: "selected",
            name: "",
            sortable: false,
            canAutoResize: false,
            draggable: false,
            resizable: false,
            headerCheckboxable: true,
            checkboxable: true,
            width: 30,
          },
          {
            name: "SNo",
            prop: "sno",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
            headerClass: "text-center",
            sortable: false,
            cellTemplate: this.snoTemplate,
            toggle: true,
            cellClass: "text-center",
          },
          {
            name: "Wo.no",
            prop: "wo_no",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Wo.Date",
            prop: "work_date",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 150,
            maxWidth: 150,
            width: 150,
          },
          {
            name: "Dc.no",
            prop: "dc_no",
            headerClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Fab Design",
            prop: "fab_design",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 120,
            maxWidth: 120,
            width: 120,
          },
          {
            name: "Shirt DNo",
            prop: "shirt_design_no",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 120,
            maxWidth: 120,
            width: 120,
          },
          {
            name: "Cu.ratio",
            prop: "cutting_ratio",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 90,
            maxWidth: 90,
            width: 90,
          },
          {
            name: "Shrinkage",
            prop: "wash_shrink",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 90,
            maxWidth: 90,
            width: 90,
          },
          {
            name: "No.of.Color",
            prop: "no_of_colors",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "No.of.Pcs",
            prop: "tot_lumps",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Width",
            prop: "width",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Fab.Style",
            prop: "fab_style",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 120,
            maxWidth: 120,
            width: 120,
          },
          {
            name: "Fab.type",
            prop: "fab_type",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Shirt.style",
            prop: "style",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },

          {
            name: "Tot.Mtrs",
            prop: "tot_mtrs",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Tot.Qty",
            prop: "tot_pcs",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Brand",
            prop: "brand",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Status",
            prop: "approvedStatus",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 120,
            maxWidth: 120,
            width: 120,
          },
        ];
      } else {
        this.columns = [
          {
            name: "SNo",
            prop: "sno",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
            headerClass: "text-center",
            sortable: false,
            cellTemplate: this.snoTemplate,
            toggle: true,
            cellClass: "text-center",
          },
          {
            name: "Fab.type",
            prop: "fab_type",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Cu.ratio",
            prop: "cutting_ratio",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 90,
            maxWidth: 90,
            width: 90,
          },
          {
            name: "Shrinkage",
            prop: "wash_shrink",
            cellClass: "text-center",
            headerClass: "text-center",
            minWidth: 90,
            maxWidth: 90,
            width: 90,
          },
          {
            name: "Brand",
            prop: "brand",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Width",
            prop: "width",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Shirt.style",
            prop: "style",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "No.of.Wo(s)",
            prop: "no_of_wo",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 90,
            maxWidth: 90,
            width: 90,
          },
          {
            name: "Tot.Mtrs",
            prop: "tot_mtrs",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Tot.Qty",
            prop: "tot_pcs",
            headerClass: "text-center",
            cellClass: "text-center",
            minWidth: 80,
            maxWidth: 80,
            width: 80,
          },
          {
            name: "Action",
            prop: "sno",
            minWidth: 100,
            maxWidth: 120,
            width: 110,
            sortable: false,
            cellTemplate: this.editDeleteTemplate,
          },
        ];
      }
    } else {
      this.columns = [
        {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: true,
          checkboxable: true,
          width: 30,
        },
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Ref No",
          prop: "ref_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Est.Ref No",
          prop: "ew_ref_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Date",
          prop: "fdate",
          headerClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "WO No",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab Design",
          prop: "fab_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Status",
          prop: "status",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Approve Status",
          prop: "approvedStatus",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Approved By",
          prop: "approvedby",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
      ];
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    if (this.menu.param == "fabric_store") {
      this.page.orderBy = "width,tot_mtrs";
      this.page.orderDir = "ASC";
    }
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getOrderList();
  }

  clearFilter(): void {
    this.filter.wo_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    this.getOrderList();
  }
  applyFilterView(row) {
    if (this.menu.param == "fabric_store") {
      this.filter.brand = row.brand;
      this.filter.fab_type = row.fab_type;
      this.filter.fab_style = row.fab_style;
      this.filter.cutting_ratio = row.cutting_ratio;
      this.filter.width = row.width;
      this.filter.style = row.style;
      this.filter.wash_shrink = row.wash_shrink;
    }
    this.getColumns();
  }
  gobacktoffGroup() {
    if (this.selected.length > 0) {
      swal("Please deselect all before going back");
      return;
    }

    this.filter.brand = "";
    this.filter.fab_type = "";
    this.filter.fab_style = "";
    this.filter.cutting_ratio = "";
    this.filter.width = "";
    this.filter.style = '';
    this.filter.wash_shrink = '';



    this.getColumns();
  }
  getOrderList(): void {
    let params = {
      start: `${this.page.offset * this.page.limit}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      wo_no: this.filter.wo_no,
      verifiedby: "NOT NULL",
      approved: this.filter.approved,
      menu: this.menu.param,
      filter: JSON.stringify(this.filter),
      //order_from_date:this.filter.order_from_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.woservice
      .getOrderList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        if (that.menu.param == "fabric_store") {
          that.total_mtrs = 0;
          that.total_wo = 0;
          that.total_qty = 0;
          that.orderList.forEach((el) => {
            that.total_mtrs += el.tot_mtrs;
            that.total_wo += el.no_of_wo;
            that.total_qty += el.tot_pcs;
          });
          that.total_mtrs =
            Math.round((that.total_mtrs + Number.EPSILON) * 100) / 100;
          that.total_wo =
            Math.round((that.total_wo + Number.EPSILON) * 100) / 100;
        }
      });
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    console.log(this.selected);

    this.tot_mtrs = 0;
    this.no_of_colors = 0;
    this.no_of_pcs = 0;
    this.no_of_wo = 0;
    this.tot_qty = 0;

    this.selected.forEach((el) => {
      this.tot_mtrs += el.tot_mtrs;
      this.no_of_colors += el.no_of_colors;
      this.no_of_pcs += el.tot_lumps;
      this.tot_qty += el.tot_pcs;
    });
    this.tot_mtrs = Math.round((this.tot_mtrs + Number.EPSILON) * 100) / 100;
    this.no_of_wo = this.selected.length;
  }
  getId(row) {
    return row.wo_id;
  }
  getIdFunction() {
    return this.getId.bind(this);
  }
  onSubmitfabStore() {
    if (this.selected.length > 0) {
      this.selectedWoNo = [];
      this.selectedWoNo = this.selected.map((el) => el.wo_id);
      let that = this;
      swal({
        title: "Are you sure to Move this Work order(s) to Cutting Plan?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Move it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        let params = {
          selectedWoNo: JSON.stringify(that.selectedWoNo),
        };
        that.isLoading = true;
        that.loadingIndicator = true;
        that.isLoadMask = that.woservice
          .moveToCuttingPlan(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.isLoading = false;

            if (res.success) {
              that.selected = [];
              that.selectedWoNo = [];
              swal("Moved to Cutting Plan on " + "C.P No " + res.data);
              that.getOrderList();
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
              let tabObj1 = {
                action: "NewTab",
                params: {
                  tabName: "F.F STORE",
                  title: "F.F STORE",
                  tabParent: "WORK ORDERS",
                  name: "F.F STORE"
                },
              };
              that.tabUpdateEvent.emit(tabObj1);
            }
          });
      });
    } else {
      swal("Select Atleast One WO.NO");
    }
  }
  onSubmitWo(mode: string, row: any) {
    if (this.selected.length > 0) {
      let listUpdateEvent = new EventEmitter();
      listUpdateEvent.subscribe(() => {
        this.selected = [];
        this.getOrderList();
        this.getIdFunction();
      });

      row = this.selected;
      row.tabevent = listUpdateEvent;
      let tabObj = {};
      if (mode == "WorkOrderDc") {
        const tabObj1 = {
          action: "CloseTab",
          params: {},
        };
        this.tabUpdateEvent.emit(tabObj1);
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "ADD CLOTH DC",
            title: "ADD CLOTH DC",
            tabParent: "CLOTH",
            mode: mode,
            data: row,
            name: "AddEditDC",
          },
        };
      }
      this.tabUpdateEvent.emit(tabObj);
    } else {
      swal("Select Atleast One WO.NO");
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/approvedWorkOrder.ts